import React, { Component } from 'react';
import Toggle from 'material-ui/Toggle';
import autoBind from 'react-autobind';
import TextField from 'material-ui/TextField';
import Money from 'src/common/entity/basic-types/Money';
import BigNumber from 'bignumber.js';
import { Currency, Entities, patch, save, search } from 'src/common';
import { connect } from 'react-redux';

class GeofenceCalculationItemCard extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            geofenceCalculation: props.item,
        };
    }

    saveGeofenceCalculation() {
        const { geofenceCalculation } = this.state;
        if (geofenceCalculation.id == null) this.props.save(geofenceCalculation, Entities.GEOFENCE_CALCULATIONS, 1);
        else this.props.patch(geofenceCalculation, Entities.GEOFENCE_CALCULATIONS, 0);
    }

    render() {
        const { item, itemId, onItemClick, t, selectedCompany } = this.props;
        const { geofenceCalculation } = this.state;
        const statusBorderColor = geofenceCalculation.active ? 'rgba(40, 167, 69, 0.5)' : 'rgba(255, 193, 7, 0.4)';
        return (
            <div
                style={Object.assign({}, styles.itemBox, styles.normalBox, {
                    borderColor: statusBorderColor,
                })}>
                <div style={styles.title}>
                    <span>{item.name}</span>
                    <div style={{ height: '72px', display: 'flex', alignItems: 'center' }}>
                        <Toggle
                            labelPosition={'right'}
                            label={t('geofence.state.active')}
                            toggled={Boolean(geofenceCalculation.active)}
                            onToggle={(event, isInputChecked) => {
                                this.setState({
                                    geofenceCalculation: {
                                        ...this.state.geofenceCalculation,
                                        active: isInputChecked,
                                    },
                                });
                            }}
                        />
                    </div>
                    <div>
                        <Toggle
                            labelPosition={'right'}
                            label={t('geofence.form.charge_on_stop')}
                            toggled={Boolean(geofenceCalculation.chargeOnStop)}
                            onToggle={(event, isInputChecked) => {
                                this.setState({
                                    geofenceCalculation: {
                                        ...this.state.geofenceCalculation,
                                        chargeOnStop: isInputChecked,
                                    },
                                });
                            }}
                        />

                        <Toggle
                            labelPosition={'right'}
                            label={t('geofence.form.charge_on_intersection')}
                            toggled={Boolean(geofenceCalculation.chargeOnIntersection)}
                            onToggle={(event, isInputChecked) => {
                                this.setState({
                                    geofenceCalculation: {
                                        ...this.state.geofenceCalculation,
                                        chargeOnIntersection: isInputChecked,
                                    },
                                });
                            }}
                        />

                        <Toggle
                            labelPosition={'right'}
                            label={t('geofence.form.charge_only_once_per_route')}
                            toggled={Boolean(geofenceCalculation.chargeOnlyOncePerTrip)}
                            onToggle={(event, isInputChecked) => {
                                this.setState({
                                    geofenceCalculation: {
                                        ...this.state.geofenceCalculation,
                                        chargeOnlyOncePerTrip: isInputChecked,
                                    },
                                });
                            }}
                        />
                    </div>
                    <div>
                        <TextField
                            type="number"
                            name="surcharge"
                            label={t('geofence.form.price')}
                            floatingLabelText={t('geofence.form.price')}
                            labelPosition="right"
                            value={geofenceCalculation.surcharge.amount ? geofenceCalculation.surcharge.amount : 0}
                            onChange={(event, value) => {
                                this.setState({
                                    geofenceCalculation: {
                                        ...this.state.geofenceCalculation,
                                        surcharge: new Money(new BigNumber(value), Currency.EUR),
                                    },
                                });
                            }}
                        />
                    </div>
                </div>
                <div style={styles.footerRow}>
                    <div
                        className="btn btn-xs transparent"
                        style={{ cursor: 'pointer' }}
                        onClick={() => onItemClick(itemId, item)}>
                        <span className="glyphicon glyphicon-map-marker" /> {t('geofence.action.show_on_map')}
                    </div>
                    <div className="btn btn-xs btn-primary" onClick={() => this.saveGeofenceCalculation()}>
                        {t('geofence.form.save_item')}
                    </div>
                </div>
            </div>
        );
    }
}

const styles = {
    itemBox: {
        backgroundColor: '#fff',
        borderRadius: '20px',
        padding: '20px',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.05)',
        cursor: 'pointer',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        minHeight: '150px',
        borderWidth: '1px',
        borderStyle: 'solid',
        transition: 'all 0.2s ease-in-out',
    },
    normalBox: {
        gridColumn: 'span 1',
    },
    expandedBox: {
        gridColumn: '1 / -1',
        backgroundColor: '#fafafa',
    },
    title: {
        fontSize: '1.6rem',
        color: '#2d3748',
        fontWeight: '600',
        margin: 0,
        textAlign: 'left',
    },
    priceContainer: {
        marginTop: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },
    priceLabel: {
        fontSize: '1rem',
        color: '#4a5568',
        fontWeight: '500',
        textAlign: 'left',
    },
    priceInput: {
        padding: '12px 16px',
        borderRadius: '8px',
        border: '1px solid #cbd5e0',
        fontSize: '1.1rem',
        outline: 'none',
        width: '100%',
        maxWidth: '250px',
        boxSizing: 'border-box',
    },
    footerRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'space-between',
        marginTop: '24px',
    },
    actionButton: {
        display: 'flex',
        alignItems: 'center',
        border: '1px solid transparent',
        padding: '10px 20px',
        borderRadius: '30px',
        cursor: 'pointer',
        fontSize: '1rem',
        fontWeight: '600',
        gap: '8px',
        outline: 'none',
        transition: 'background-color 0.2s, color 0.2s',
    },
    deactivateButton: {
        backgroundColor: '#fff1f1',
        color: '#e53e3e',
        border: '1px solid #fed7d7',
    },
    activateButton: {
        backgroundColor: '#ebf8ff',
        color: '#3182ce',
        border: '1px solid #bee3f8',
    },
    icon: {
        width: '18px',
        height: '18px',
    },
};

export default connect(null, { patch, save, search })(GeofenceCalculationItemCard);
